import React from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  useTheme,
  Fade,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarIcon from "@mui/icons-material/Star";
import { motion } from "framer-motion";
export default function CoopItem({ idx, category }) {
  const theme = useTheme();
  return (
    <Box key={idx} mb={{ xs: 10, md: 14 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 5,
          borderRight: `4px solid ${theme.palette.primary.main}`,
          pr: 2,
        }}
      >
        <Typography
          variant="h6"
          mb={"0"}
          fontWeight="bold"
          color="text.primary"
        >
          {category.title}
        </Typography>
      </Box>

      <Grid container spacing={2} justifyContent="center">
        {category.plans.map((plan, index) => (
          <Grid
            size={{ xs: 12, md: 6, lg: 4 }}
            key={index}
            sx={{
              transform: plan.popular ? "scale(1.02)" : "scale(1)",
              transition: "transform 0.3s ease",
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx == 0 ? 0 : 0.3 }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <Card
                sx={{
                  height: "100%",
                  position: "relative",
                  backgroundColor: "background.paper",
                  borderRadius: 4,
                  transition: "all 0.3s ease",
                  border: plan.popular
                    ? `2px solid ${theme.palette.primary.main}`
                    : `1px solid ${theme.palette.background.lightGray}`,
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: `0 20px 40px ${theme.palette.primary.lowOpacity}`,
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {plan.popular && (
                  <Chip
                    label="پرطرفدارترین"
                    icon={<StarIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      position: "absolute",
                      top: 16,
                      left: 16,
                      right: "auto",
                      bgcolor: "primary.main",
                      color: "primary.contrastText",
                      fontWeight: "bold",
                      fontSize: "0.75rem",
                      px: 1,
                    }}
                    size="small"
                  />
                )}

                <CardContent sx={{ p: 4 }}>
                  {/* title*/}
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                    color="text.primary"
                    gutterBottom
                  >
                    {plan.duration}
                  </Typography>

                  {/* price */}
                  <Box textAlign="center" mb={3}>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      sx={{
                        color: theme.palette.primary.main,
                      }}
                    >
                      {plan.price}
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{ color: "text.secondary", mr: 0.5 }}
                      >
                        تومان
                      </Typography>
                    </Typography>
                  </Box>

                  {/* descriptions */}
                  <Typography
                    variant="body2"
                    textAlign="center"
                    sx={{
                      color: "text.secondary",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      pb: 2,
                      mb: 2,
                    }}
                  >
                    {plan.description}
                  </Typography>

                  {/* features */}
                  <List dense sx={{ mb: 3 }}>
                    {plan.features.map((feature, i) => (
                      <ListItem key={i} sx={{ px: 0, py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 32 }}>
                          <CheckCircleIcon
                            sx={{
                              fontSize: 20,
                              color: theme.palette.success.main,
                            }}
                          />
                        </ListItemIcon>
                        <Typography variant="body2" color="text.secondary">
                          {feature}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>

                  {/* button */}
                  <Button
                    fullWidth
                    variant={plan.popular ? "contained" : "outlined"}
                    color="primary"
                    size="large"
                    sx={{
                      py: 1.5,
                      borderRadius: 3,
                      fontWeight: "bold",
                      ...(plan.popular
                        ? {}
                        : {
                            borderColor: theme.palette.primary.main,
                            "&:hover": {
                              borderColor: theme.palette.primary.light,
                              backgroundColor: theme.palette.primary.lowOpacity,
                            },
                          }),
                    }}
                  >
                    انتخاب طرح {plan.duration}
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
